var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.394 8.001.603 9.885c.047.756.687 1.364 1.485 1.364h6.71c.78 0 1.414-.583 1.483-1.32L17.583 8c-1.662-.106-3.877-.223-5.583-.223-1.714 0-3.941.118-5.606.224m12.686.101.747.057.112.009a.75.75 0 0 0 .122-1.495l-.117-.01a112 112 0 0 0-1.493-.109c-1.692-.116-4.41-.277-6.451-.277s-4.76.161-6.451.277a163 163 0 0 0-1.493.11l-.116.009a.75.75 0 0 0 .12 1.495m0 0 .113-.01.725-.054.602 9.873c.096 1.568 1.412 2.773 2.982 2.773h6.71c1.535 0 2.835-1.153 2.976-2.683l.912-9.965",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.6 4.75a.25.25 0 0 0-.25.25v1.595a.75.75 0 0 1-1.5 0V5c0-.966.783-1.75 1.75-1.75h2.8c.966 0 1.75.784 1.75 1.75v1.595a.75.75 0 0 1-1.5 0V5a.25.25 0 0 0-.25-.25z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.05 6.595a.75.75 0 0 1 .75-.75h1.6a.75.75 0 0 1 0 1.5H8.8a.75.75 0 0 1-.75-.75M12.85 6.595a.75.75 0 0 1 .75-.75h1.6a.75.75 0 0 1 0 1.5h-1.6a.75.75 0 0 1-.75-.75M12 10.169a.75.75 0 0 1 .75.75v5.19a.75.75 0 0 1-1.5 0v-5.19a.75.75 0 0 1 .75-.75M8.8 11.034a.75.75 0 0 1 .75.75v3.46a.75.75 0 0 1-1.5 0v-3.46a.75.75 0 0 1 .75-.75M15.2 11.034a.75.75 0 0 1 .75.75v3.46a.75.75 0 0 1-1.5 0v-3.46a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgTrash;